import RichText from '~/src/common/components/CMS/RichText';
import I18n from '~/src/common/services/I18n';
import { GetRecipeByIdOrSlug200 } from '~/src/queries/api-ecom/generated/api-ecom.schemas';
import IngredientItem from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/IngredientItem';

import * as S from './layout';

interface Props {
  steps: GetRecipeByIdOrSlug200['steps'];
}

const RecipePreparation = ({ steps }: Props) => {
  return (
    <S.StepsSection>
      <S.StepsSectionHeader>
        <S.SectionName>{I18n.t('recipe-screen.steps-title')}</S.SectionName>
      </S.StepsSectionHeader>
      {steps.map(({ description, ingredients }, index) => (
        <S.StepContainer key={`${description.substring(0, 10)}-${ingredients?.[0]?.name}`}>
          <S.StepNumber>{index + 1}</S.StepNumber>
          <RichText html={description} />
          {ingredients.length > 0 ? (
            <S.IngredientsList>
              {ingredients.map(i => (
                <IngredientItem key={i.name} ingredient={i} />
              ))}
            </S.IngredientsList>
          ) : null}
        </S.StepContainer>
      ))}
    </S.StepsSection>
  );
};

export default RecipePreparation;
